// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VHFpN","colBig":"styles_colBig__4-g46","colSmall":"styles_colSmall__3DsC1"};